'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getCarousels();
  }

  getCarousels() {
    this.$http.get(`/api/carousels`).then(res => {
      this.carousels = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete('/api/carousels/' + id).then(res => {
        this.getCarousels();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/carousel/list/list.controller.js